// src/components/MultiAxisLineChart.js
import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Registrar los elementos de Chart.js
ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

// Colores de utilidad
const CHART_COLORS = {
  red: "rgb(255, 99, 132)",
  blue: "rgb(54, 162, 235)",
};

// Función para crear colores transparentes
const transparentize = (color, opacity = 0.5) =>
  color.replace("rgb", "rgba").replace(")", `, ${opacity})`);

// Datos de ejemplo
const labels = ["January", "February", "March", "April", "May", "June", "July"];
const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: [65, 59, 80, 81, 56, 55, 40],
      borderColor: CHART_COLORS.red,
      backgroundColor: transparentize(CHART_COLORS.red, 0.5),
      yAxisID: "y",
    },
    {
      label: "Dataset 2",
      data: [-45, -20, -60, -40, -75, -30, -20],
      borderColor: CHART_COLORS.blue,
      backgroundColor: transparentize(CHART_COLORS.blue, 0.5),
      yAxisID: "y1",
    },
  ],
};

// Configuración del gráfico
const options = {
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: "Chart.js Line Chart - Multi Axis",
    },
  },
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
    },
    y1: {
      type: "linear",
      display: true,
      position: "right",
      grid: {
        drawOnChartArea: false, // solo las líneas del eje izquierdo
      },
    },
  },
};

const Chart4 = () => {
  return <Line data={data} options={options} />;
};

export default Chart4;
